import React from "react";
import { Heading, Subheading } from "../design/heading";
import clsx from "clsx";

interface Props {
  title?: string;
  message?: string;
  action?: React.ReactNode;
  className?: string;
}

const EmptyStateView: React.FC<Props> = ({
  title,
  message,
  action,
  className,
}) => {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center w-full h-32 space-y-2",
        className,
      )}
    >
      {title && <Heading>{title}</Heading>}
      {message && <Subheading>{message}</Subheading>}
      {action}
    </div>
  );
};

export default EmptyStateView;
